import { Plus, Trash2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";

export function MappingTab({ canMappingWrite, mappings, onOpenMap, onDeleteMapping }) {
  return (
    <>
      <div className="flex items-center justify-between">
        <p className="text-xs text-slate-500 max-w-2xl leading-relaxed">
          Regole di mapping: campo sorgente → trasformazione → metrica canonica Social.
          I valori non mappati non vengono mai ignorati silenziosamente: finiscono in TO_REVIEW.
        </p>
        {canMappingWrite && (
          <Button size="sm" className="bg-green-700 hover:bg-green-800" onClick={onOpenMap} data-testid="add-mapping-btn">
            <Plus className="w-4 h-4 mr-1" aria-hidden="true" /> Nuovo mapping
          </Button>
        )}
      </div>
      <Card className="border-slate-200">
        <CardContent className="p-0 overflow-x-auto">
          <Table data-testid="mappings-table">
            <TableHeader>
              <TableRow><TableHead>Sistema</TableHead><TableHead>Campo sorgente</TableHead><TableHead>Trasformazione</TableHead><TableHead>Metrica canonica</TableHead><TableHead>Datapoint</TableHead>{canMappingWrite && <TableHead className="text-right">Azioni</TableHead>}</TableRow>
            </TableHeader>
            <TableBody>
              {mappings.length === 0 && (
                <TableRow><TableCell colSpan={6} className="text-center text-slate-500 py-6" data-testid="mappings-empty">Nessuna regola di mapping configurata.</TableCell></TableRow>
              )}
              {mappings.map((m) => (
                <TableRow key={m.id} data-testid={`mapping-row-${m.id.slice(0, 8)}`}>
                  <TableCell className="text-sm">{m.source_system}</TableCell>
                  <TableCell className="text-sm font-mono">{m.source_field}</TableCell>
                  <TableCell><Badge variant="outline" className="text-[10px] bg-slate-50">{m.transformation}</Badge></TableCell>
                  <TableCell className="text-sm">{m.canonical_metric}</TableCell>
                  <TableCell className="text-xs text-slate-500">{m.target_datapoint || "—"}</TableCell>
                  {canMappingWrite && (
                    <TableCell className="text-right">
                      <Button size="sm" variant="ghost" className="text-red-700" onClick={() => onDeleteMapping(m.id)} data-testid={`mapping-delete-${m.id.slice(0, 8)}`}>
                        <Trash2 className="w-4 h-4" aria-hidden="true" />
                      </Button>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </>
  );
}
